import { useLocation } from "react-router-dom";

export const useModuleName = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const moduleName = pathname.split("/").pop() || "";
  return { moduleName, pathname };
};
